'use client'

import { useEffect, useState } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import {
  getConversationPhishingPassiveReminder,
  updateConversationPhishingPassiveReminder,
} from '@marketplace-web/conversation-safety/conversation-safety-data'

import PhishingReminderBannerExperiment from './PhishingReminderBannerExperiment'

type Props = {
  threadId: string
}

const PhishingReminderBanner = ({ threadId }: Props) => {
  const [isBannerDismissed, setIsBannerDismissed] = useState(false)

  const { fetch: fetchConversationPhishingPassiveReminder, data } = useFetch(
    getConversationPhishingPassiveReminder,
  )

  useEffect(() => {
    fetchConversationPhishingPassiveReminder(threadId)
  }, [fetchConversationPhishingPassiveReminder, threadId])

  const handleBannerDismiss = async () => {
    setIsBannerDismissed(true)

    await updateConversationPhishingPassiveReminder(threadId, { hidden: true })
  }

  if (!data || data.hidden || isBannerDismissed) return null

  return (
    <PhishingReminderBannerExperiment threadId={threadId} onBannerDismiss={handleBannerDismiss} />
  )
}

export default PhishingReminderBanner
